(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["diy-battery-organizer"] && !Shopify.designMode) return;
  try {
    
function initializeBatteryShops() {
  document.querySelectorAll('[data-battery-shop]').forEach(shop => {
    if (shop.dataset.initialized) return;
    shop.dataset.initialized = 'true';
    const filters = shop.querySelector('[data-battery-filters]');
    if (!filters) return;
    filters.hidden = false;
    const series = shop.querySelector('[data-battery-series]');
    const available = shop.querySelector('[data-battery-available]');
    const cards = [...shop.querySelectorAll('[data-battery-product]')];
    const groups = [...shop.querySelectorAll('[data-battery-group]')];
    const update = () => {
      cards.forEach(card => {
        card.hidden = !!((series?.value && card.dataset.configuration !== series.value) || (available.checked && card.dataset.available !== 'true'));
      });
      groups.forEach(group => {
        group.hidden = ![...group.querySelectorAll('[data-battery-product]')].some(card => !card.hidden);
      });
      shop.querySelector('[data-battery-empty]').hidden = cards.some(card => !card.hidden);
    };
    filters.addEventListener('change', update);
    shop.querySelector('[data-battery-reset]').addEventListener('click', () => {
      if (series) series.value = '';
      available.checked = false;
      update();
    });
    update();
  });
}
initializeBatteryShops();
document.addEventListener('shopify:section:load', initializeBatteryShops);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diy-busbar-guide-library"] && !Shopify.designMode) return;
  try {
    
  function initializeBusbarLibraries(scope) {
    scope.querySelectorAll('[data-diy-busbar-library]').forEach(function (library) {
      if (library.dataset.selectorInitialized === 'true') return;
      library.dataset.selectorInitialized = 'true';
      var selector = library.querySelector('[data-kit-select]');
      var panels = Array.from(library.querySelectorAll('[data-kit-panel]'));
      var announcement = library.querySelector('[data-selection-announcement]');
      function showSelection(announce) {
        panels.forEach(function (panel) {
          panel.hidden = panel.dataset.series !== selector.value;
        });
        if (announce) {
          var active = panels.find(function (panel) { return !panel.hidden; });
          if (active) announcement.textContent = active.querySelector('h2').textContent.trim();
        }
      }
      selector.addEventListener('change', function () { showSelection(true); });
      showSelection(false);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initializeBusbarLibraries(document); }, { once: true });
  } else {
    initializeBusbarLibraries(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    initializeBusbarLibraries(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diy500amp-cell-intelligence"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function updatePlanner(root) {
      var limit = Number(root.dataset.currentLimit || 0);
      var packCurrent = Number(root.querySelector('[data-pack-current]').value || 0);
      var parallel = Math.max(1, Number(root.querySelector('[data-parallel-count]').value || 1));
      var perCell = packCurrent / parallel;
      var result = root.querySelector('[data-current-per-cell]');
      var status = root.querySelector('[data-planner-status]');
      var resultBox = root.querySelector('.diy-cell-profile__planner-result');
      result.textContent = (Math.round(perCell * 10) / 10) + 'A';
      if (perCell > limit) {
        resultBox.dataset.state = 'over';
        status.textContent = root.dataset.overText;
      } else if (perCell > limit * 0.8) {
        resultBox.dataset.state = 'near';
        status.textContent = root.dataset.nearText;
      } else {
        resultBox.dataset.state = 'safe';
        status.textContent = root.dataset.safeText;
      }
    }

    function initializePlanners() {
      document.querySelectorAll('[data-diy-cell-planner]').forEach(function (root) {
        updatePlanner(root);
        root.addEventListener('input', function () {
          updatePlanner(root);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializePlanners);
    } else {
      initializePlanners();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diy500amp-p50b-intelligence"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function updatePlanner(root) {
      var limit = Number(root.dataset.currentLimit || 0);
      var packCurrent = Number(root.querySelector('[data-pack-current]').value || 0);
      var parallel = Math.max(1, Number(root.querySelector('[data-parallel-count]').value || 1));
      var perCell = packCurrent / parallel;
      var result = root.querySelector('[data-current-per-cell]');
      var status = root.querySelector('[data-planner-status]');
      var resultBox = root.querySelector('.diy-cell-profile__planner-result');
      result.textContent = (Math.round(perCell * 10) / 10) + 'A';
      if (perCell > limit) {
        resultBox.dataset.state = 'over';
        status.textContent = root.dataset.overText;
      } else if (perCell > limit * 0.8) {
        resultBox.dataset.state = 'near';
        status.textContent = root.dataset.nearText;
      } else {
        resultBox.dataset.state = 'safe';
        status.textContent = root.dataset.safeText;
      }
    }

    function initializePlanners() {
      document.querySelectorAll('[data-diy-cell-planner]').forEach(function (root) {
        updatePlanner(root);
        root.addEventListener('input', function () {
          updatePlanner(root);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializePlanners);
    } else {
      initializePlanners();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
